import React from "react";
import { Link } from "react-router-dom";
import CONSTANT from "./../../../constant";
import Paging from "./../../../component/common/Paging";
import Loader from "./../../../component/common/Loader";
import { formatDateDDMMYY } from "./../../../utils";

class appraisalAcceptanceManager extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      page: 1,
      limit: 50,
      list: undefined,
      count: 0,
      showLoader: false,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = "Team Appraisal - " + CONSTANT.organisation.name;
    this.loadList();
  }

  render() {
    const { page, list, showLoader } = this.state;

    return (
      <div className="container-fluid mb-3">
        <div className="row">
          <div className="col-md-12">
            <div className="card homedob">
              <div className="row">
                <div className="col-md-12">
                  <h1 className="page-title">Appraisal List</h1>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12 mt-3">
                  <div className="list-container">
                    <div className="table-container">
                      <div className="table-wrapper radius-4">
                        <table className="tablen">
                          <thead>
                            <tr className="text-center">
                              <th className="table-dark">#</th>
                              <th className="table-dark">Name</th>
                              <th className="table-dark">Status</th>
                              <th className="table-dark">Created On</th>
                              <th className="table-dark">Action</th>
                            </tr>
                          </thead>

                          <tbody>
                            {list === undefined && (
                              <tr>
                                <td colSpan={10} className="text-center">
                                  Loading...
                                </td>
                              </tr>
                            )}

                            {list !== undefined && list.length === 0 && (
                              <tr>
                                <td colSpan={10} className="text-center">
                                  No Employees found.
                                </td>
                              </tr>
                            )}

                            {list !== undefined &&
                              list.map((item: any, index: number) => {
                                const editUrl = CONSTANT.component.aparEditAppraisalCycle.url.replace(
                                  ":code",
                                  item.code
                                );
                                return (
                                  <tr
                                    key={item.code}
                                    className="c-pointer"
                                    onClick={() => this.props.history.push(editUrl)}
                                  >
                                    <td>{(this.state.page - 1) * this.state.limit + index + 1}</td>
                                    <td>{item.cycleName}</td>
                                    <td>{item.financialYear}</td>
                                    <td className="text-center">
                                      {item.isMouApplicable
                                        ? <span className="badge badge-success">Yes</span>
                                        : <span className="badge badge-secondary">No</span>}
                                    </td>
                                    <td>
                                      {item.isMouApplicable
                                        ? <span>20% MoU + 55% KPAs</span>
                                        : <span>75% KPAs</span>}
                                    </td>
                                    <td>{formatDateDDMMYY(item.startDate)}</td>
                                    <td>{formatDateDDMMYY(item.endDate)}</td>
                                    <td>
                                      <span
                                        className={`badge ${
                                          item.status === "Active"
                                            ? "badge-success"
                                            : item.status === "Completed"
                                            ? "badge-secondary"
                                            : item.status === "Cancelled"
                                            ? "badge-danger"
                                            : "badge-warning"
                                        }`}
                                      >
                                        {item.status}
                                      </span>
                                    </td>
                                    <td>{formatDateDDMMYY(item.createdOn)}</td>
                                    <td
                                      className="text-center"
                                      onClick={(e) => e.stopPropagation()}
                                    >
                                      <Link
                                        to={editUrl}
                                        className="btn btn-sm btn-primary mr-2"
                                      >
                                        <i className="fa fa-pencil" />
                                      </Link>
                                    </td>
                                  </tr>
                                );
                              })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {list !== undefined && (
                <Paging
                  page={page}
                  listItem={list}
                  onPageChange={this.changePage}
                />
              )}
            </div>
          </div>
        </div>
        {showLoader && <Loader />}
      </div>
    );
  }

  loadList = () => {
    // TODO: Replace with actual API call
    // getappraisalAcceptanceManager(page, limit).then((res: any) => {
    //   this.setState({ list: res.result.list, count: res.result.count });
    // });
    this.setState({ list: [] });
  };

  changePage = (e: any) => {
    const type = e.target.dataset.type;
    const page = type === "+" ? this.state.page + 1 : this.state.page - 1;
    this.setState({ page }, () => {
      this.loadList();
    });
  };
}

export default appraisalAcceptanceManager;